<template>
  <div class="">
    <div>
      <HeaderTop></HeaderTop>
      <Header></Header>
      <router-view class="w-100"/>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LayoutApp',
  components: {
    HeaderTop: () => import('@/components/HeaderTop.vue'),
    Header: () => import('@/components/Header.vue'),
    Footer: () => import('@/components/Footer.vue'),
  }
}

</script>
